<template>
  <div>
    <form @submit.prevent="doSearch" class="my-2">
      <div class="clearfix">
        <div class="float-right center-align">
          <b-input-group class="mb-1">
            <b-form-select v-model="filterStatus" :options="statusList || defaulStatusList">
            </b-form-select>
            <b-form-select
              class="ml-2"
              v-model="searchMode"
              :options="searchOptions || defaultSearchModes"
              ></b-form-select>
            <search-format-modal class="ml-2 mt-1"></search-format-modal>
          </b-input-group>
        </div>
      </div>

      <simple-search class="mb-2" v-if="searchMode == 'simple'" :filters="filters" />
      <free-text-search class="mb-2" v-if="searchMode == 'freetext'" />
      <advanced-search class="mb-2" v-if="searchMode == 'advanced'" />
      <custom-search class="mb-2" v-if="searchMode == 'custom'" />

      <div class="text-center">
        <b-button
          id="search-btn"
          type="submit"
          variant="primary"
          class="mr-1"
          @click="doSearch"
          :disabled="states.searching"
        >
          <em class="fa fa-search mr-2"></em>
          {{ $t("buttons.search") }}
        </b-button>
        <b-button
          variant="secondary"
          @click="resetSearch"
          :disabled="states.searching"
        >{{ $t('buttons.reset') }}</b-button>
      </div>
    </form>

    <b-alert variant="danger" :show="errorMessage != null">
      <em class="fa fa-times-circle mr-2"></em>
      {{ errorMessage }}
    </b-alert>
  </div>
</template>

<script>
import { useSearch } from "../../stores/search";
export default {
  props: {
    statusList: null,
    searchOptions: null,
    filters: {
      default: () => [
        {
          field: 'id',
          label: 'ID'
        },
        {
          field: 'name',
          label: 'name'
        }
      ]
    },
  },
  computed: {
    states() {
      return this.useSearch.states;
    },
    searchMode: {
      get() {
        return this.useSearch.searchMode;
      },
      set(val) {
        this.useSearch.setSearchMode(val);
      },
    },
    errorMessage() {
      return this.useSearch.errorMessage;
    },
    filterStatus: {
      get() {
        return this.useSearch.activeFilter.status;
      },
      set(value) {
        this.useSearch.updateActiveFilter(value);
        this.useSearch.updateStates({
          searching: true,
        });
      }
    },
  },
  data() {
    return {
      defaultSearchModes: [
        { value: 'simple', text: this.$t('commons.simple_mode') },
        { value: 'freetext', text: this.$t('commons.free_text_mode') },
        { value: 'advanced', text: this.$t('commons.advanced_mode') },
      ],
      defaulStatusList: [
        { value: null, text: this.$t('commons.filter_by_status') },
        { value: 'active', text: this.$t('commons.filter_active') },
        { value: 'inactive', text: this.$t('commons.filter_inactive') },
        { value: 'all', text: this.$t('commons.filter_all') },
      ],
      useSearch: useSearch()
    }
  },
  methods: {
    doSearch() {
      this.useSearch.setErrorMessage(null);

      this.useSearch.updateStates({
        searching: true,
      });
    },
    resetSearch() {
        this.useSearch.resetSearch();
    },
  },
};
</script>
